/**
 * Invite Token Hook
 *
 * Centralizes invite token persistence across auth pages.
 * The invite token originates from the URL path (/invite/{token}) and needs
 * to survive navigation to /login, /signup, /verify-email pages.
 * Uses sessionStorage as the source of truth so the token isn't lost
 * if search params are dropped during navigation or page reloads.
 */

const STORAGE_KEY = 'pendingInviteToken';

/**
 * Persist an invite token (call from InviteAccept page).
 */
export function storeInviteToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

/**
 * Clear the stored invite token (call after successful acceptance).
 */
export function clearInviteToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

/**
 * Read the invite token from search params or sessionStorage.
 * Search param takes priority if present.
 */
export function useInviteToken(searchInvite?: string): string | undefined {
  if (searchInvite) {
    // Also store it so it survives further navigation
    sessionStorage.setItem(STORAGE_KEY, searchInvite);
    return searchInvite;
  }
  return sessionStorage.getItem(STORAGE_KEY) ?? undefined;
}
